/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import s from './ServicesFooter.scss';

class WideLogo extends React.Component {

  render() {
    return (
      <div className="wide-logo">
        <img
          role="presentation"
          src={
            this.props.districts && Object.keys(this.props.districts)
              .filter(urzad => urzad === this.props.prefix)
              .map(urzad => this.props.districts[urzad].footerLogo,
            )
          }
          width={'100%'}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(WideLogo));



// WEBPACK FOOTER //
// src/components/ServicesFooter/WideLogo.js